import {
    API
} from "../http-common";

const RESOURCE_NAME = "/BaseDocumentaire";

export default {
    getCategories() {
        return API.get(`${RESOURCE_NAME}/Categories`);
    },
    getCategoriesInfo() {
        return API.get(`${RESOURCE_NAME}/CategoriesInfo`);
    },
    getCategoriesOptions() {
        return API.get(`${RESOURCE_NAME}/CategoriesOptions`);
    },
    AddCategorie(data) {
        return API.post(`${RESOURCE_NAME}/Categories`, data);
    },
    EditCategorie(data) {
        return API.put(`${RESOURCE_NAME}/Categories`, data);
    },
    getLastCategoriePosition(parentId) {
        if(parentId == undefined || parentId == null)
        return API.get(`${RESOURCE_NAME}/LastCategoriePosition`);
        else
            return API.get(`${RESOURCE_NAME}/LastCategoriePosition?parentId=${parentId}`);
    },
    deleteCategory(id) {
        return API.delete(`${RESOURCE_NAME}/Categories?id=${id}`);
    },
    reUpCategorie(id) {
        return API.post(`${RESOURCE_NAME}/reUpCategorie?id=${id}`);
    },
    getFile(fileId, affilieId) {
        return API.get(`${RESOURCE_NAME}/GetFile?fileId=${fileId}${affilieId ? '&affilieId='+affilieId : ''}`, {
            responseType: 'blob'
        });
    },
    getArticles() {
        return API.get(`${RESOURCE_NAME}/Articles`);
    },
    getArticlesListing(catId) {
        return API.get(`${RESOURCE_NAME}/ArticlesListing?category=${catId}`);
    },
    AddArticle(data){
        return API.post(`${RESOURCE_NAME}/Article`, data);
    },
    EditArticle(data){
        return API.put(`${RESOURCE_NAME}/Article`, data);
    },
    AddArticleMesDocs(data){
        return API.post(`${RESOURCE_NAME}/ArticleMesDocs`, data);
    },
    getArticle(id) {
        return API.get(`${RESOURCE_NAME}/Article?id=${id}`);
    },
    deleteArticle(id) {
        return API.delete(`${RESOURCE_NAME}/Article?id=${id}`);
    },
    getCategorieInfo(id){
        return API.get(`${RESOURCE_NAME}/GetCategory?id=${id}`);
    },
    getSearchTerms(searchTerm, limit){
        return API.get(`${RESOURCE_NAME}/SearchTerms?term=${searchTerm}&limit=${limit}`);
    },
    searchArticles(searchTerm, limit){
        return API.get(`${RESOURCE_NAME}/Search?searchTerm=${searchTerm}&limit=${limit}`);
    },
    deleteItem(itemId) {
        return API.delete(`${RESOURCE_NAME}/DeleteItem?itemId=${itemId}`);
    },
};